// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/zahnrad-aus-polyoxymethylen/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteZahnradAusPolyoxymethylenDE: PageEntry = {
  id: "example.produkte-zahnrad-aus-polyoxymethylen",
  locale: "de",
  slug: "produkte/zahnrad-aus-polyoxymethylen",
  seo: {
    title: "Zahnrad aus Polyoxymethylen | Dietz GmbH",
    description: "Zahnrad aus Polyoxymethylen (POM) zur Kraftübertragung im Automobilbereich.",
  },
  type: "post",
  h1: "Zahnrad aus Polyoxymethylen",
  intro: "Zahnrad aus Polyoxymethylen (POM) zur Kraftübertragung im Automobilbereich.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_Zahnrad_Polyoxymethylen.jpg", alt: "Zahnrad Polyoxymethylen", width: 800, height: 640 }
  ],
};
